export default {
  'refunds.sectionTitle': 'Refunds',
  'refunds.menuTitle': 'Refunds',
  'partners.menuTitle': 'Partners',
  'refunds.title': 'Refunds',
  'refunds.tab.all': 'All',
  'refunds.tab.processing': 'Processing',
  'refunds.tab.completed': 'Completed',
  'refunds.tab.completed2': 'Completed',
  'refunds.refundStatus.CREATED': 'Created',
  'refunds.refundStatus.FAILED,': 'Failed',
  'refunds.refundStatus.PROCESSED,': 'Processing',
  'refunds.refundStatus.COMPLETED,': 'Completed',
  'refunds.refundStatus.PENDING_APPROVAL,': 'Pending approval',
  'refunds.refundStatus.REJECTED,': 'Rejected',
  'refunds.error.title.400.005.017': 'Pending refund',
  'refunds.error.description.400.005.017':
    'There is pending refund request(s) for the same order. Please act upon them prior to any new refund actions',
  'refunds.error.title.400.005.020': "Refund isn't available at the moment",
  'refunds.error.description.400.005.020':
    "You can't create a refund for this order because a chargeback has been raised.",
  'refunds.error.title.400.005.021': "Refund isn't available at the moment",
  'refunds.error.description.400.005.021':
    'There are additional fees applied on this order. Please reverse these fees before issuing the refund.',
};
